import React from 'react';

const ClienteDialogContent = ({ cliente }) => {

    const mailLink = "mailto: " + cliente.email;

    return (
    <div className="ClienteDialogContainer">

      <div>
        <p className="ClienteTipoTitle">Tipo de cliente</p>
        <p className="Personeria">
          <span className="ti ti-user violeta-claro"></span>&nbsp;
          {cliente.personeria}
        </p>

      </div>

      <div className="ContactoDiv RowText">

        <h3 className="ContactoTitle">Contacto</h3>

        <hr className="Divider" />

        <p className="CorreoTitle">Correo electrónico</p>
        <p>
          <a className="MailLink" href={mailLink}>{cliente.email}</a>
        </p>

        <div className="Telefonos" style={{display: 'flex'}}>

         <span style={{ marginRight: '65px'}}>
            <p className="TelefonoText">Teléfono 1</p>
            <p className="FieldValue">{cliente.telefono1}</p>
          </span>

          <span className="Telefono2Container">
            <p className="TelefonoText">Teléfono 2</p>
            <p className="FieldValue">{cliente.telefono2}</p>
          </span>

        </div>

        <div className="Domicilios" style={{ display: 'flex' }}>

          <span className="DomicilioLegal">
              <p className="DomicilioText">Domicilio legal</p>
              <p className="FieldValue">{cliente.domicilioLegal}</p>
          </span>

          <span className="DomicilioParticular">
            <p className="DomicilioText">Domicilio particular</p>
            <p className="FieldValue">{cliente.domicilioParticular}</p>
          </span>

        </div>

      </div>

    </div>
    );

}

export default ClienteDialogContent;
